(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Claude"] && !Shopify.designMode) return;
  try {
    
(function() {
  var secciones = document.querySelectorAll('.tc-seccion');

  secciones.forEach(function(seccion) {
    var contenedorSlider = seccion.querySelector('[data-tc-slider-texto]');
    var slidesTexto = seccion.querySelectorAll('[data-tc-slide-texto]');
    var slidesImagen = seccion.querySelectorAll('[data-tc-slide-imagen]');
    var botonPrev = seccion.querySelector('[data-tc-prev]');
    var botonNext = seccion.querySelector('[data-tc-next]');
    var contenedorImagen = seccion.querySelector('[data-tc-touch]');
    var total = slidesTexto.length;
    var indiceActual = 0;
    var autoplayActivo = seccion.dataset.autoplay === 'true';
    var velocidadAutoplay = parseInt(seccion.dataset.velocidadAutoplay || '5', 10) * 1000;
    var temporizador = null;
    var temporizadorResize = null;

    function medirAlturaMaxima() {
      var mayor = 0;

      slidesTexto.forEach(function(slide) {
        var estiloOriginal = slide.getAttribute('style') || '';
        slide.style.display = 'block';
        slide.style.position = 'absolute';
        slide.style.visibility = 'hidden';
        slide.style.top = '0';
        slide.style.left = '0';
        slide.style.width = '100%';

        var altura = slide.offsetHeight;

        if (altura > mayor) {
          mayor = altura;
        }

        slide.setAttribute('style', estiloOriginal);
      });

      return mayor;
    }

    function ajustarAlturaContenedor() {
      if (!contenedorSlider) {
        return;
      }
      var mayor = medirAlturaMaxima();
      contenedorSlider.style.height = mayor + 'px';
    }

    if (total > 0) {
      ajustarAlturaContenedor();
    }

    window.addEventListener('resize', function() {
      clearTimeout(temporizadorResize);
      temporizadorResize = setTimeout(ajustarAlturaContenedor, 150);
    });

    if (total <= 1) {
      return;
    }

    function mostrarSlide(indice) {
      slidesTexto.forEach(function(slide) {
        slide.classList.remove('tc-slide-texto--activo');
      });
      slidesImagen.forEach(function(slide) {
        slide.classList.remove('tc-slide-imagen--activo');
      });
      slidesTexto[indice].classList.add('tc-slide-texto--activo');
      slidesImagen[indice].classList.add('tc-slide-imagen--activo');
      indiceActual = indice;
    }

    function siguienteSlide() {
      var nuevoIndice = (indiceActual + 1) % total;
      mostrarSlide(nuevoIndice);
    }

    function anteriorSlide() {
      var nuevoIndice = (indiceActual - 1 + total) % total;
      mostrarSlide(nuevoIndice);
    }

    function iniciarAutoplay() {
      if (!autoplayActivo) {
        return;
      }
      temporizador = setInterval(siguienteSlide, velocidadAutoplay);
    }

    function detenerAutoplay() {
      if (temporizador) {
        clearInterval(temporizador);
        temporizador = null;
      }
    }

    if (botonNext) {
      botonNext.addEventListener('click', function() {
        siguienteSlide();
        detenerAutoplay();
        iniciarAutoplay();
      });
    }

    if (botonPrev) {
      botonPrev.addEventListener('click', function() {
        anteriorSlide();
        detenerAutoplay();
        iniciarAutoplay();
      });
    }

    if (contenedorImagen) {
      var puntoInicioX = 0;
      var puntoFinX = 0;

      contenedorImagen.addEventListener('touchstart', function(evento) {
        puntoInicioX = evento.changedTouches[0].screenX;
      }, { passive: true });

      contenedorImagen.addEventListener('touchend', function(evento) {
        puntoFinX = evento.changedTouches[0].screenX;
        var diferencia = puntoInicioX - puntoFinX;

        if (Math.abs(diferencia) > 50) {
          if (diferencia > 0) {
            siguienteSlide();
          } else {
            anteriorSlide();
          }
          detenerAutoplay();
          iniciarAutoplay();
        }
      }, { passive: true });
    }

    seccion.addEventListener('mouseenter', detenerAutoplay);
    seccion.addEventListener('mouseleave', iniciarAutoplay);

    iniciarAutoplay();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["More"] && !Shopify.designMode) return;
  try {
    
(function() {
  var secciones = document.querySelectorAll('.tc-seccion');

  secciones.forEach(function(seccion) {
    var slidesTexto = seccion.querySelectorAll('[data-tc-slide-texto]');
    var slidesImagen = seccion.querySelectorAll('[data-tc-slide-imagen]');
    var botonPrev = seccion.querySelector('[data-tc-prev]');
    var botonNext = seccion.querySelector('[data-tc-next]');
    var contenedorImagen = seccion.querySelector('[data-tc-touch]');
    var total = slidesTexto.length;
    var indiceActual = 0;
    var autoplayActivo = seccion.dataset.autoplay === 'true';
    var velocidadAutoplay = parseInt(seccion.dataset.velocidadAutoplay || '5', 10) * 1000;
    var temporizador = null;

    if (total <= 1) {
      return;
    }

    function mostrarSlide(indice) {
      slidesTexto.forEach(function(slide) {
        slide.classList.remove('tc-slide-texto--activo');
      });
      slidesImagen.forEach(function(slide) {
        slide.classList.remove('tc-slide-imagen--activo');
      });
      slidesTexto[indice].classList.add('tc-slide-texto--activo');
      slidesImagen[indice].classList.add('tc-slide-imagen--activo');
      indiceActual = indice;
    }

    function siguienteSlide() {
      var nuevoIndice = (indiceActual + 1) % total;
      mostrarSlide(nuevoIndice);
    }

    function anteriorSlide() {
      var nuevoIndice = (indiceActual - 1 + total) % total;
      mostrarSlide(nuevoIndice);
    }

    function iniciarAutoplay() {
      if (!autoplayActivo) {
        return;
      }
      temporizador = setInterval(siguienteSlide, velocidadAutoplay);
    }

    function detenerAutoplay() {
      if (temporizador) {
        clearInterval(temporizador);
        temporizador = null;
      }
    }

    if (botonNext) {
      botonNext.addEventListener('click', function() {
        siguienteSlide();
        detenerAutoplay();
        iniciarAutoplay();
      });
    }

    if (botonPrev) {
      botonPrev.addEventListener('click', function() {
        anteriorSlide();
        detenerAutoplay();
        iniciarAutoplay();
      });
    }

    if (contenedorImagen) {
      var puntoInicioX = 0;
      var puntoFinX = 0;

      contenedorImagen.addEventListener('touchstart', function(evento) {
        puntoInicioX = evento.changedTouches[0].screenX;
      }, { passive: true });

      contenedorImagen.addEventListener('touchend', function(evento) {
        puntoFinX = evento.changedTouches[0].screenX;
        var diferencia = puntoInicioX - puntoFinX;

        if (Math.abs(diferencia) > 50) {
          if (diferencia > 0) {
            siguienteSlide();
          } else {
            anteriorSlide();
          }
          detenerAutoplay();
          iniciarAutoplay();
        }
      }, { passive: true });
    }

    seccion.addEventListener('mouseenter', detenerAutoplay);
    seccion.addEventListener('mouseleave', iniciarAutoplay);

    iniciarAutoplay();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coleccion"] && !Shopify.designMode) return;
  try {
    
(function() {
  var tarjetas = document.querySelectorAll('.ppd-tarjeta');

  tarjetas.forEach(function(tarjeta) {
    var imagenPrincipal = tarjeta.querySelector('[data-ppd-imagen-principal]');
    var miniaturas = tarjeta.querySelectorAll('[data-ppd-miniatura]');

    miniaturas.forEach(function(miniatura) {
      miniatura.addEventListener('click', function(evento) {
        evento.preventDefault();

        if (!imagenPrincipal) {
          return;
        }

        var nuevaSrc = miniatura.getAttribute('data-src-completa');
        imagenPrincipal.setAttribute('src', nuevaSrc);

        miniaturas.forEach(function(otra) {
          otra.classList.remove('ppd-miniatura--activa');
        });

        miniatura.classList.add('ppd-miniatura--activa');
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["millon"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function inicializar(seccion) {
      if (!seccion || seccion.dataset.categoriasPortadaInit === 'true') return;
      var carrusel = seccion.querySelector('[data-categorias-portada-carrusel]');
      var barra = seccion.querySelector('[data-categorias-portada-progreso-barra]');
      var contenedor = seccion.querySelector('[data-categorias-portada-progreso]');
      if (!carrusel || !barra || !contenedor) return;

      seccion.dataset.categoriasPortadaInit = 'true';

      function actualizar() {
        var contenedorAncho = contenedor.clientWidth;
        var scrollTotal = carrusel.scrollWidth - carrusel.clientWidth;

        if (scrollTotal <= 0 || contenedorAncho <= 0) {
          barra.style.width = '100%';
          barra.style.transform = 'translate3d(0, 0, 0)';
          return;
        }

        var proporcionVisible = carrusel.clientWidth / carrusel.scrollWidth;
        var porcentajeBarra = Math.max(proporcionVisible * 100, 20);
        var anchoBarraPx = (porcentajeBarra / 100) * contenedorAncho;
        var maxDesplazamientoPx = contenedorAncho - anchoBarraPx;
        var progreso = carrusel.scrollLeft / scrollTotal;
        if (progreso < 0) progreso = 0;
        if (progreso > 1) progreso = 1;
        var desplazamientoPx = progreso * maxDesplazamientoPx;

        barra.style.width = porcentajeBarra + '%';
        barra.style.transform = 'translate3d(' + desplazamientoPx + 'px, 0, 0)';
      }

      var tickScroll = false;
      carrusel.addEventListener('scroll', function () {
        if (!tickScroll) {
          window.requestAnimationFrame(function () {
            actualizar();
            tickScroll = false;
          });
          tickScroll = true;
        }
      }, { passive: true });

      var tickResize = false;
      window.addEventListener('resize', function () {
        if (!tickResize) {
          window.requestAnimationFrame(function () {
            actualizar();
            tickResize = false;
          });
          tickResize = true;
        }
      });

      if (window.ResizeObserver) {
        var ro = new ResizeObserver(function () { actualizar(); });
        ro.observe(carrusel);
      }

      window.setTimeout(actualizar, 50);
      window.setTimeout(actualizar, 300);
      actualizar();
    }

    function iniciarTodas() {
      var secciones = document.querySelectorAll('[data-categorias-portada]');
      for (var i = 0; i < secciones.length; i++) inicializar(secciones[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciarTodas);
    } else {
      iniciarTodas();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('[data-categorias-portada]');
      if (s) inicializar(s);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
